import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  private loading = signal<boolean>(false);
  isLoading = this.loading.asReadonly();

  private activeRequests = 0;

  public setOverlayLoading(isShown: boolean) {
    if (isShown) {
      this.activeRequests++;
      if (this.activeRequests === 1) {
        this.loading.set(true);
      }
      return;
    }

    this.activeRequests--;
    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      this.loading.set(false);
    }
  }
}
